module.exports = __webpack_public_path__ + "static/media/logo_black.6bf8d651.png";